import Vue from 'vue';

const success = (data, context) => {
    // Stripe.setPublishableKey(data.public_key);
    context.stripe = Stripe(data.public_key);
    context.elements = context.stripe.elements();
    context.payment = data.payment;
    context.stripeEmail = data.payment.customer_email;
    context.userCurrency = data.payment.booking && data.payment.booking.rental.currency ? data.payment.booking.rental.currency.symbol : data.payment.user.currency.symbol;
    context.rentalInfo = data.rentalInfo;
    let captured = '';
    if(context.payment.captured == 0) {
        captured = $('#paymentInfoForm .button-submit').attr('data-captured-deposit');
    } else {
        captured = $('#paymentInfoForm .button-submit').attr('data-captured-payment');
    }
    context.pageTitle = `${captured} ${context.payment.amount} ${context.userCurrency} - ${context.payment.title} ${context.payment.description}`;
    context.error = false;
    context.loading = false;
};

const failed = (context, error, permalink) => {
    if (error.msg === 'paid') {
      Vue.router.push({
          name: 'payment.success',
          params: {
                permalink: permalink,
                status: 'success',
            },
        });
        context.error = true;
        context.loading = false;
    } else if (error.msg === 'not_exists') {
        const language = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
        const errorMessage = language === 'en' ? 'The link does not exist anymore' : 'Le lien n\'est plus actif';
        toastr.error(errorMessage);
    } else {
        context.error = error.msg;
        context.loading = false;
    }
};

export default (context, permalink) => {
    return Vue.$http.get('/p/'+permalink)
        .then((response) => {
            if (response && response.status === 200) {
                success(response.data, context);
            }
        })
        .catch((error) => {
            failed(context,  error.response.data,permalink);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/payment/getByPermalink.js